module.exports = true;



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src560599644/src/~/core-js/library/modules/_library.js
// module id = 5D9A
// module chunks = 6